/**
 * @file 快速上手数据
 * @author FengGuang(fengguang01@baidu.com)
 */

import picture1 from '../../../../images/quickstart/picture1.png';
import picture2 from '../../../../images/quickstart/picture2.png';
import picture3 from '../../../../images/quickstart/picture3.png';

export interface IQuickOnhandItem {
    title: string;
    text: string;
    img: string;
    link: string;
    tagText: string;
}

const quickOnhandData: IQuickOnhandItem[] = [
    {
        title: '线性回归',
        text: '了解机器学习中的若干重要概念，并使用真实的数据集建立起一个房价预测模型',
        img: picture1,
        link: '/documentation/docs/zh/beginners_guide/basics/fit_a_line/README.cn.html',
        tagText: '新手问题'
    },
    {
        title: '识别数字',
        text: '从简单的Softmax回归模型开始，了解如何改进模型并利用多层感知机和卷积神经网络优化识别效果',
        img: picture2,
        link: '/documentation/docs/zh/beginners_guide/basics/recognize_digits/README.cn.html',
        tagText: '计算机视觉'
    },
    {
        title: '词向量',
        text: '了解基于神经网络训练词向量的细节，以及如何用 Paddle Fluid 训练一个词向量模型',
        img: picture3,
        link: '/documentation/docs/zh/beginners_guide/basics/word2vec/index.html',
        tagText: '自然语言处理'
    }
];

export default quickOnhandData;
